import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as lib from '~/dependencies';
import * as actions from '~/store/actions';

export default function Logout() {
  const dispatch = useDispatch();
  const ua = useSelector(state => state.phone?.ua);

  useEffect(() => {
    ua?.stop();
    dispatch(actions.logout());
  }, [dispatch, ua]);

  return <lib.Redirect to="/auth" />;
}
